import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=f64d6864&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=f64d6864&prod&lang=css"
import style1 from "./MainLayout.vue?vue&type=style&index=1&id=f64d6864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64d6864",
  null
  
)

export default component.exports